import React, { useEffect, useState } from "react";
import DataTable from "../../common/dataTable";
import { Grid, Radio } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { useDispatch, useSelector } from "react-redux";
import masterActions from "../../redux/master/actions";
import dayjs from "dayjs";
import { itemsPerPage } from "../../utils/constants";
import TablePagination from "../../common/tablePagination";
import eligibilityCriteriaActions from "../../redux/eligibilityCriteria/actions";

export default function EligibilityTable({eligibilityCriteria}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { backofficeTokenDetails } = useSelector(state => state.authReducer);

  // const { eligibilityCriteria } = useSelector(state => state.eligibilityCriteriaReducer)
  const [tableData, setTableData] = useState([]);
  const [itemOffset, setItemOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  useEffect(() => {
    createTabledata()
  }, [eligibilityCriteria]);


  
  const handleActive = (active, type, eligibilitycriteriaid) => {
    if (type !== active) {
      let data = {
        userid: backofficeTokenDetails?.id,
        eligibilitycriteriaid: eligibilitycriteriaid,
        isactive: type
      }
      dispatch({
        type: eligibilityCriteriaActions.SET_ACTIVE_ELIGIBILITY,
        payload: { data: data },
      });
    }
  }
  const createTabledata = () => {
    if (!eligibilityCriteria || !Array.isArray(eligibilityCriteria)) return;
  
    let data = eligibilityCriteria.map((obj, index) => ({
      id: index + 1, 
      eligibilitycriteriaid:obj.eligibilitycriteriaid,
      eligibilitycriterianame: obj.eligibilitycriterianame || "N/A",
      // criteria_option: obj.criteria_option === "0" ? "Rejection" : obj.criteria_option === "1" ? "Minimum" : "N/A",
      criteria_option: obj.criteria_option === 0 ? "Rejection" : obj.criteria_option === 1 ? "Minimum" :obj.criteria_option === 2 ? "Success" : "N/A",
      nationalityid: obj.nationalityid || "N/A",
      ismhcandidate: obj.ismhcandidate === "1" ? "Yes" : "No",
      categoryid: Array.isArray(obj.categoryid) ? obj.categoryid.join(", ") : obj.categoryid,
      enable: (
        <Radio
          checked={obj.isactive === "1"}
          onClick={() => handleActive(obj.isactive, "1", obj.eligibilitycriteriaid)}
        />
      ),
      disable: (
        <Radio
          checked={obj.isactive === "0"}
          onClick={() => handleActive(obj.isactive, "0", obj.eligibilitycriteriaid)}
        />
      ),
    }));
  
    setTableData(data);
  };
  



  // useEffect(() => {
  //   dispatch({ type: eligibilityCriteriaActions.GET_ELIGIBILITY_CRITERIA })
  // }, [])
  const tableKeys = [
    {
      name: "S.No",
      accessor: "id",
      sortOption: false,
    },
    {
      name: "Eligibility Criteria Name",
      accessor: "eligibilitycriterianame",
      sortOption: false,
    },
    {
      name: "Criteria Option",
      accessor: "criteria_option",
      sortOption: false,
    },
    {
      name: "Enable",
      accessor: "enable",
      sortOption: false,

    },
    {
      name: "Disable",
      accessor: "disable",
      sortOption: false,
    },
  ];

 

  const handleEligibilityUpdate = (val) => {
    navigate(`/${Cookies.get("mhet_mst_project")}/eligibility-management?page=updateeligibility`, { state: { id: val } });
  }

 

  const endOffset = itemOffset + itemsPerPage;
  const currentItems = tableData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(tableData?.length / itemsPerPage);

  const handlePageChange = (event, value) => {
    const newOffset = (value - 1) * itemsPerPage;
    setItemOffset(newOffset);
    setCurrentPage(value);
  };

  return (
    <Grid>
      <DataTable
        keys={tableKeys}
        values={currentItems}
        page={"eligibilitycriteria"}
        handleEligibilityUpdate={handleEligibilityUpdate}
      />
      <TablePagination
        pageCount={pageCount}
        handlePageChange={handlePageChange}
        currentPage={currentPage}
      />
    </Grid>
  );
}
